// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Ikmyz","link":"styles_link__xz4UA","image":"styles_image__Gkvf5","button":"styles_button__FA5s4"};